<template>
    <div class="pageBox">
        <Header ref="Header" current='souye'></Header>
        <contactBanner :showMarBot="navList.length <= 0" :list="list[0]" @goScroll='goScroll' ref="contactBanner">
        </contactBanner>
        <!-- <div v-if="module_type == 4 && content.length" class="pageBox_cen">
            <tbas :navList="navList"></tbas>
            <titleBar domId="navBar0" :title="content[0].moduleTitle"></titleBar>
            <tabCarousel :list="content[0].list[0].list" :title="content[0].list[0].moduleTitle"></tabCarousel>
            <imageTwoGap :list="content[0].list[1].list"></imageTwoGap>
            <titleBar domId="navBar1" :title="content[1].moduleTitle"></titleBar>
            <myBanner2 :title="content[1].list[0].moduleTitle" :list="content[1].list[0].list"></myBanner2>
            <imagOne :title="content[1].list[1].moduleTitle" :desc="content[1].list[1].desc"
                :url="content[1].list[1].url"></imagOne>
            <imageTwo :dataInfo="content[1].list[2]"></imageTwo>
            <tabCarousel :list="content[1].list[3].list" :title="content[1].list[3].moduleTitle"></tabCarousel>
            <tabCarousel :list="content[1].list[4].list" :title="content[1].list[4].moduleTitle"></tabCarousel>
            <imageTwoGap :dataInfo="content[1].list[5]"></imageTwoGap>
            <downloads :title="content[1].list[6].moduleTitle" :list="content[1].list[6].list"></downloads>
            <titleBar domId="navBar2" :title="content[2].moduleTitle"></titleBar>
            <products :list="content[2].list"></products>
        </div>
        <div v-else-if="module_type == 3 && content.length" class="pageBox_cen">
            <tbas :navList="navList"></tbas>
            <titleBar domId="navBar0" :title="content[0].moduleTitle"></titleBar>
            <tabCarousel :list="content[0].list[0].list" :title="content[0].list[0].moduleTitle"></tabCarousel>
            <imageTwoGap :list="content[0].list[1].list"></imageTwoGap>
            <titleBar domId="navBar1" :title="content[1].moduleTitle"></titleBar>
            <myBanner :title="content[1].list[0].moduleTitle" :list="content[1].list[0].list"></myBanner>
            <template v-for="item in content[1].list[1].list">
                <imagOne :title="content[1].list[1].moduleTitle" :url="item.cover" :desc="item.title"></imagOne>
            </template>
<downloads :title="content[1].list[2].moduleTitle" :list="content[1].list[2].list"></downloads>
<products :list="content[2].list"></products>
</div>
<div v-else-if="module_type == 2 && content.length" class="pageBox_cen">
    <tbas :navList="navList"></tbas>
    <titleBar domId="navBar0" :title="content[0].moduleTitle"></titleBar>
    <imagOne :title="content[0].list[0].title" :url="content[0].list[0].cover"></imagOne>
    <myBanner :title="content[1].moduleTitle" :list="content[1].list"></myBanner>
    <template v-for="item in content[2].list">
                <imagOne :full_screen="item.full_screen" :title="item.title" :url="item.cover" :desc="item.desc">
                </imagOne>
            </template>
    <titleBar domId="navBar1" :title="content[1].moduleTitle"></titleBar>
    <products :list="content[3].list"></products>
</div>
<div v-else-if="module_type == 1 && content.length" class="pageBox_cen">
    <tbas :navList="navList"></tbas>
    <titleBar domId="navBar0" :title="content[0].moduleTitle"></titleBar>
    <template v-for="item in content[0].list">
                <imagOne :title="item.title" :url="item.cover"></imagOne>
            </template>
    <titleBar domId="navBar1" :title="content[1].moduleTitle"></titleBar>
    <products :list="content[1].list"></products>
</div>
<div v-else-if="module_type == 0" class="pageBox_cen">
    <div class="imagDetail" v-if="id == 'd2e61610-c1f4-11ef-bcc2-cb1625e53d0d'">
        <img v-for="(item, index) in images" :key="index" :src="item" alt="">
    </div>
    <div v-else class="modelDetail">
        <template v-for="item in module2">
                    <imagOne :full_screen="item.full_screen" :title="item.title" :url="item.cover" :desc="item.desc">
                    </imagOne>
                </template>
    </div>
</div> -->

        <!-- <div v-if="id == 'd2e61610-c1f4-11ef-bcc2-cb1625e53d0d' || id == 'dbc55b60-c1f4-11ef-bcc2-cb1625e53d0d'"
            class="pageBox_cen">
            <div class="imagDetail" v-if="id == 'd2e61610-c1f4-11ef-bcc2-cb1625e53d0d'">
                <img v-for="(item, index) in images" :key="index" :src="item" alt="">
            </div>
            <div v-else class="modelDetail">
                <template v-for="item in module2">
                    <imagOne :full_screen="item.full_screen" :title="item.title" :url="item.cover" :desc="item.desc">
                    </imagOne>
                </template>
            </div>
        </div> -->

        <div class="pageBox_cen">
            <tbas v-if="navList.length" :currenId="currenId" :navList="navList"></tbas>
            <template v-for="item in content">
                <template v-if="item.type == 1">
                    <template v-for="item2 in item.content">
                        <imagOne :title="item2.title" :url="item2.cover"></imagOne>
                    </template>
                </template>

                <template v-else-if="item.type == 2">
                    <products :list="item.content"></products>
                </template>

                <template v-else-if="item.type == 3">
                    <imagOne :title="item.title" :type="item.content.type" :url="item.content.url"></imagOne>
                </template>

                <template v-else-if="item.type == 4">
                    <myBanner :title="item.title" :backgroundImage="item.big_bg" :list="item.content"></myBanner>
                </template>

                <template v-else-if="item.type == 5">
                    <imagOne :title="item.title" :type="item.content.c_type" :desc="item.content.c_title"
                        :url="item.content.c_cover"></imagOne>
                </template>

                <template v-else-if="item.type == 6">
                    <myBanner2 :title="item.title" :list="item.content"></myBanner2>
                </template>

                <template v-else-if="item.type == 7">
                    <tabCarousel :list="item.content" :showTitle="item.type7_is_show_title" :title="item.title">
                    </tabCarousel>
                </template>

                <template v-else-if="item.type == 8">
                    <imageTwoGap :dataInfo="item"></imageTwoGap>
                </template>

                <template v-else-if="item.type == 9">
                    <downloads :title="item.title" :list="item.content"></downloads>
                </template>

                <template v-else-if="item.type == 12">
                    <imageTwo :title="item.title" :dataInfo="item.content"></imageTwo>
                </template>

                <template v-else-if="item.type == 13">
                    <titleBar @titleShowChange="titleShowChange" :domId="item.key" :title="item.moduleTitle"></titleBar>
                </template>

                <template v-else-if="item.type == 14">
                    <imagOne v-for="item2 in item.content" :key="item2.id" :full_screen="item2.full_screen" :title="item2.title" :url="item2.cover" :desc="item2.desc">
                    </imagOne>
                </template>

                <template v-else-if="item.type == 15">
                    <div class="imagDetail">
                        <img v-for="(item2, index) in item.content" :key="index" :src="item2" alt="">
                    </div>
                </template>
            </template>
        </div>

        <div :class="showService ? 'serviceShow' : ''" class="service">
            <i @click="showService = false" class="el-icon-close"></i>
            <div class="title">{{ serviceData.title }}</div>
            <div class="avatar">
                <img src="@/assets/index/kf-ava.png" alt="" />
            </div>
            <div class="text1">
                {{ serviceData.name }}
            </div>
            <div class="text2">
                {{ serviceData.contact_us }}
            </div>
            <div @click="$openUrl(serviceData.kefu_jump_url); showService = false" class="btnBox">
                {{ serviceData.btn_text }}
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from "@/components/header.vue"
import Footer from "@/components/footer.vue"
import contactBanner from "@/components/c/contactBanner.vue"
import tbas from "./components/tbas.vue"
import titleBar from "./components/titleBar.vue"
import tabCarousel from "./components/tabCarousel.vue"
import imageTwoGap from "./components/imageTwoGap.vue"
import myBanner from "./components/myBanner.vue"
import myBanner2 from "./components/myBanner2.vue"
import imagOne from "./components/imagOne.vue"
import imageTwo from "./components/imageTwo.vue"
import downloads from "./components/downloads.vue"
import products from "./components/products.vue"
import mapComponent from "@/components/mapComponent.js"
import { get_product_detail } from '@/api/product'
export default {
    components: {
        Header,
        Footer,
        contactBanner,
        tbas,
        titleBar,
        tabCarousel,
        imageTwoGap,
        myBanner,
        imagOne,
        imageTwo,
        downloads,
        products,
        myBanner2,
    },
    data() {
        return {
            mapComponent,
            list: [{
                name: 'contactBanner',
                value: '设备轮播图',
            }, {
                name: 'productHost',
                value: '设备详情',
            }],
            navHidden: false, // 导航栏是否隐藏
            lastScrollTop: 0, // 上一次页面滚动的位置
            currentRoute: '',

            id: null,
            product_id: null,
            navList: [],
            content: [],
            images: [],
            module2: [],

            showService: false,
            serviceData: {},

            currenId: '',
        }
    },
    created() {
        let { id, product_id } = this.$route.query
        if (id && product_id) {
            this.id = id
            this.product_id = product_id
            this.getProductDetailInfo()
        }

        this.$bus.$on('setServiceData', (data) => {
            this.showService = true
            this.serviceData = data
        })
    },


    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        this.currentRoute = this.$route.path; // 初始化时获取当前路由地址
        this.$watch('$route', this.onRouteChange);
        var element;
        if (this.nowVibe == 'pc') {
            element = document.documentElement
        } else {
            element = document.documentElement.scrollTop ? document.documentElement : document.body;
        }
        let scrollTop = element.scrollTop;
        if (scrollTop == 0) {
            if (!this.$refs.Header.navHead) {
                this.$refs.Header.headerHover = false;
            }
            this.$refs.Header.headerTrue = false;
        } else {
            this.$refs.Header.headerTrue = true;
            this.$refs.Header.headerHover = true;
        }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
        this.$bus.$off('setServiceData')
    },
    methods: {
        onRouteChange(newRoute, oldRoute) {
            this.currentRoute = newRoute.path; // 更新当前路由地址
            // this.$refs.productCen[0].querValue = this.$route.query.value;
            // this.goScroll(this.$route.query.value)
        },
        handleScroll() {
            const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body
                .scrollTop || 0;
            if (currentScrollTop > this.lastScrollTop) {
                this.navHidden = true;
            } else {
                this.navHidden = false;
            }
            this.lastScrollTop = currentScrollTop;

            // this.$refs.productCen[0].navHidden = this.navHidden;
            if (currentScrollTop == 0) {
                if (!this.$refs.Header.navHead) {
                    this.$refs.Header.headerHover = false;
                } else {
                    this.$refs.Header.mouseoverLi(3);
                }
                this.$refs.Header.headerTrue = false;
            } else {
                this.$refs.Header.headerTrue = true;
                this.$refs.Header.headerHover = true;
            }
        },
        goScroll(e) {
            this.lastScrollTop = e;
            // document.documentElement.scrollTop = e+10;
            var element;
            if (this.nowVibe == 'pc') {
                element = document.documentElement
            } else {
                element = document.documentElement.scrollTop ? document.documentElement : document.body;
            }
            element.scrollTop = e + 10;
            // document.documentElement.scrollTop=0
        },

        getProductDetailInfo() {
            let params = { id: this.id, product_id: this.product_id }
            get_product_detail(params).then(res => {
                this.navList = res.data.nav.map((el, index) => {
                    return {
                        name: el,
                        key: '#navBar' + index,
                    }
                })
                if (this.navList.length) {
                    res.data.content = res.data.content.map(el => {
                        if (el.is_nav == 1) {
                            let index = this.navList.findIndex(item => item.name === el.moduleTitle)
                            el.key = 'navBar' + index
                        }
                        return el
                    })
                }
                this.content = res.data.content
                this.$nextTick(() => {
                    this.$refs['contactBanner'].setList(res.data.banner);

                    // if (this.id == 'd2e61610-c1f4-11ef-bcc2-cb1625e53d0d') {
                    //     this.$refs['contactBanner'].setList(res.data.content.module1.banner);
                    //     this.images = res.data.content.module1.images
                    // } else if (this.id == 'dbc55b60-c1f4-11ef-bcc2-cb1625e53d0d') {
                    //     this.$refs['contactBanner'].setList(res.data.banner);
                    //     this.module2 = res.data.content.module2
                    // } else {
                    //     this.$refs['contactBanner'].setList(res.data.banner);
                    // }
                })
            })
        },
        titleShowChange(idStr) {
            this.currenId = idStr
        },
    },
}
</script>

<style scoped lang="scss">
.pageBox {
    display: flex;
    flex-direction: column;
    min-height: 100vh;

    .pageBox_cen {
        flex: 1;

        .imagDetail {
            width: 1200px;
            margin: auto;
            margin-bottom: 116px;

            img {
                width: 100%;
                display: block;
            }
        }

        .modelDetail {
            margin-bottom: 116px;
        }
    }
}

.service {
    width: 400px;
    background: #fff;
    box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.17);
    border-radius: 10px;
    padding: 22px;
    position: fixed;
    right: -500px;
    bottom: 63px;
    z-index: 999;
    transition: all 0.3s;
    background-image: url('../../assets/index/kefu-bg.png');
    background-repeat: no-repeat;
    background-size: 104px 135px;
    background-position: right 100px;

    .el-icon-close {
        font-size: 16px;
        font-weight: bold;
        position: absolute;
        right: 17px;
        top: 15px;
        cursor: pointer;

    }

    .title {
        text-align: center;
        font-weight: bold;
        font-size: 16px;
        color: #000000;
        margin-top: 12px;
        white-space: pre-wrap;
    }

    .avatar {
        display: flex;
        justify-content: center;
        margin-top: 18px;

        img {
            width: 80px;
            height: 80px;
            vertical-align: bottom;
            border-radius: 50%;
        }

    }

    .text1 {
        margin-top: 14px;
        font-weight: 400;
        font-size: 16px;
        color: #000000;
        text-align: center;
    }

    .text2 {
        font-weight: 400;
        font-size: 13px;
        color: #898989;
        line-height: 18px;
        margin-top: 12px;
        text-align: center;
    }

    .btnBox {
        width: 200px;
        height: 35px;
        line-height: 35px;
        background: #1A2580;
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
        margin: auto;
        margin-top: 20px;
        text-align: center;
        cursor: pointer;
    }
}

.serviceShow {
    right: 70px;
}

@media screen and (max-width:1200px) {
    .pageBox {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
        overflow-x: hidden;

        .pageBox_cen {
            flex: 1;
            min-width: 0;
            max-width: 100%;

            .imagDetail {
                width: 100%;
                margin: auto;
                margin-top: 50px;

                img {
                    width: 100%;
                    display: block;
                }
            }

            .modelDetail {
                margin-bottom: 50px;
            }
        }
    }
}
</style>
